import React, { CSSProperties } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
type FormVariant = 'stack' | 'frame' | 'steps';
type FormTone = 'dark' | 'light';
interface ArchitecturalFormProps {
  variant?: FormVariant;
  tone?: FormTone;
  className?: string;
}
const PLATE_COUNT = 5;
export function ArchitecturalForm({
  variant = 'stack',
  tone = 'dark',
  className = ''
}: ArchitecturalFormProps) {
  const reduceMotion = useReducedMotion();
  const plates = Array.from({
    length: PLATE_COUNT
  }, (_, i) => i);
  return <div aria-hidden="true" className={`relative aspect-square w-full ${className}`} style={{
    perspective: '1200px'
  }} data-id="element-461" data-mp="13770upywbt6r">
      <motion.div className="absolute inset-[16%]" style={{
      transformStyle: 'preserve-3d',
      rotateX: 58
    }} initial={{
      rotateZ: -40
    }} animate={reduceMotion ? {
      rotateZ: -40
    } : {
      rotateZ: [-40, -28, -40]
    }} transition={reduceMotion ? {
      duration: 0
    } : {
      duration: 16,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-462" data-mp="1hw3bmusc7kb2">
        {plates.map(i => <div key={i} className="absolute inset-0 rounded-[3px]" style={plateStyle(variant, tone, i)} data-id="element-463" data-mp="27iduy75tsxtt" />)}
        <div className="absolute left-1/2 top-1/2 -ml-1.5 -mt-1.5 h-3 w-3 rounded-full bg-copper" style={{
        transform: `translateZ(${PLATE_COUNT * 32 + 36}px)`
      }} data-id="element-464" data-mp="2bie8zqp0j70c" />
      </motion.div>
    </div>;
}
function plateStyle(variant: FormVariant, tone: FormTone, i: number): CSSProperties {
  const isTop = i === PLATE_COUNT - 1;
  const fill = tone === 'dark' ? isTop ? 'rgba(166,95,70,0.22)' : `rgba(248,245,240,${0.035 + i * 0.025})` : isTop ? 'rgba(48,29,50,0.92)' : `rgba(48,29,50,${0.05 + i * 0.05})`;
  const border = tone === 'dark' ? isTop ? 'rgba(212,154,127,0.95)' : 'rgba(212,154,127,0.4)' : isTop ? '#A65F46' : 'rgba(48,29,50,0.22)';
  let transform = '';
  let background = fill;
  if (variant === 'stack') {
    transform = `translateZ(${i * 32}px) scale(${1 - i * 0.15})`;
  } else if (variant === 'frame') {
    transform = `translateZ(${i * 34}px) rotateZ(${i * 9}deg) scale(${1 - i * 0.06})`;
    background = isTop ? fill : 'transparent';
  } else {
    transform = `translateZ(${i * 28}px) translate(${(i - 2) * 9}%, ${(2 - i) * 9}%) scale(0.68)`;
  }
  return {
    transform,
    background,
    border: `1px solid ${border}`
  };
}